import { render, staticRenderFns } from "./RAViewNew.vue?vue&type=template&id=08c00df4&scoped=true&lang=pug&"
import script from "./RAViewNew.vue?vue&type=script&lang=js&"
export * from "./RAViewNew.vue?vue&type=script&lang=js&"
import style0 from "./RAViewNew.vue?vue&type=style&index=0&id=08c00df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c00df4",
  null
  
)

export default component.exports